export const useCmsStore = defineStore('cms', () => {
  const html = ref()
  const name = computed(() => html.value.name)
  const content = computed(() => html.value.cmsPage.sections[0].blocks[0].slots[0].data.content)
  const metaTitle = computed(() => html.value.metaTitle || html.value.name)
  const metaDescription = computed(() => html.value.metaDescription)
  const init = async ({ id, url }: { id: string, url: string }) => {
    const htmlData = await useFetch(`/store-api/url/${id}`, {
      method: 'POST',
      query: {
        url
      }
    })
    html.value = htmlData.data.value
  }

  return { name, content, metaTitle, metaDescription, init }
})
